// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DeleteButton-module_fullwidth_ag4kL,
.DeleteButton-module_fullwidth_ag4kL > span {
  display: block !important;
  /*height: 100%;*/
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/client/components/Generic/Buttons/DeleteButton.module.css"],"names":[],"mappings":"AAAA;;EAEE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[".fullwidth,\n.fullwidth > span {\n  display: block !important;\n  /*height: 100%;*/\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fullwidth": `DeleteButton-module_fullwidth_ag4kL`
};
export default ___CSS_LOADER_EXPORT___;
